import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  getCustomers: [],
  getPagination: null,
  getDealership: [],
  getDealershipPagination: null,
};

const CompanyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CUSTOMER:
      if (
        state?.getPagination?.meta?.current_page !=
        action.payload?.meta?.current_page
      ) {
        let customer_list = [];
        customer_list = [...state.getCustomers, ...action.payload.data];
        state = {
          ...state,
          getPagination: action.payload,
          getCustomers: customer_list,
        };
      } 
      else {
        state = { ...state, getCustomers: action.payload.data, getPagination: action.payload };
      }
      break;
    case ActionTypes.RESET_CUSTOMER:
      state = { ...state, getCustomers: [], getPagination: null };
      break;
    case ActionTypes.GET_DEALERSHIP:
      if (
        state?.getDealershipPagination?.meta?.current_page !=
        action.payload?.meta?.current_page
      ) {
        let dealership_list = [];
        dealership_list = [...state.getDealership, ...action.payload.data];
        state = {
          ...state,
          getDealershipPagination: action.payload,
          getDealership: dealership_list,
        };
      } else {
        state = { ...state, getDealership: action.payload.data, getDealershipPagination: action.payload };
      }
      break;
    case ActionTypes.RESET_DEALERSHIP:
      state = { ...state, getDealership: [], getDealershipPagination: null };
      break;
  }
  return state;
};

export default CompanyReducer;
